import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "fw-b" }
const _hoisted_2 = { class: "fw-b" }
const _hoisted_3 = { class: "fw-b" }
const _hoisted_4 = { slot: "time-label" }

import { IonCol, IonRow, IonDatetime } from "@ionic/vue";
import { computed, ref } from "vue";
import { route } from "@/router";
import { DateTime } from "luxon";

import InputSimple from "@/components/input/InputSimple.vue";
import CheckboxSimple from "@/components/checkbox/CheckboxSimple.vue";
import SelectSimple from "@/components/selects/SelectSimple.vue";
import ButtonFix from "@/components/button/ButtonFix.vue";

import { useListStore } from "@/stores/lists";

import { useLanguageArray } from "@/composables/useLanguageArray";

import { Reminder } from "@/types/supplier";
import { REPEAT_CYCLE, WEEKDAY } from "@/types/enum/general";
import { INPUT_TYPE } from "@/types/enum/ionicEnum";
import { TimerSettingsProps } from "@/types/props";
import { TimerSettingsEmits } from "@/types/emits";

import { isPlatform } from "@ionic/core";


export default /*@__PURE__*/_defineComponent({
  __name: 'TimerSettings',
  props: {
    timer: {},
    cssClass: {},
    settings: { type: Boolean }
  },
  emits: ["save", "editd"],
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v64583217": (ionDateWheelHighlight.value),
  "v46467caa": (ionDateBorder.value)
}))

const props = __props


const listStore = useListStore()

const today = ref(DateTime.now().toString())
const timerSettings = ref<Reminder>(props.timer)

const { content: repeatOptions } = useLanguageArray([
    { value: REPEAT_CYCLE.ONCE, text: `enumT.repeatCycle.${REPEAT_CYCLE.ONCE}` },
    { value: REPEAT_CYCLE.WEEK, text: `enumT.repeatCycle.${REPEAT_CYCLE.WEEK}` },
], 'text')

const isValid = computed<boolean>(() => {
    if (timerSettings.value.type === REPEAT_CYCLE.ONCE) {
        return Boolean(timerSettings.value.date && (timerSettings.value.listId || route.value.params.listId))
    }
    return Boolean(
        timerSettings.value.interval?.time &&
        timerSettings.value.interval.days.length &&
        timerSettings.value.interval.every &&
        (timerSettings.value.listId || route.value.params.listId)
    )
})

const changeTimeDays = (value: boolean, day: WEEKDAY): void => {
    if (!value) {
        const index = timerSettings.value.interval?.days.findIndex(timerDay => timerDay === day)

        if (index < 0) return

        timerSettings.value.interval?.days.splice(index, 1)
        return
    }

    timerSettings.value.interval?.days.push(day)
}

const ionDateWheelHighlight = computed(() => isPlatform('android') ? '#ffdbea' : '')
const ionDateBorder = computed(() => isPlatform('android') ? '1px solid var(--ion-color-grey3-tint)' : '')


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(route).params.listId)
      ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), {
              class: _normalizeClass(__props.cssClass)
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('label.list')), 1),
                _createVNode(SelectSimple, {
                  modelValue: timerSettings.value.listId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timerSettings.value.listId) = $event)),
                  class: "mt-1 grey4-grey4-background inherit-background purple-purple-color max-width chevron-select max-width-custom",
                  placeholder: _ctx.$t('target.list'),
                  options: _unref(listStore).lists.data,
                  valueKey: "id",
                  textKey: "name"
                }, null, 8, ["modelValue", "placeholder", "options"])
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(IonRow), { class: "width-custom" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonCol), {
          class: _normalizeClass(__props.cssClass)
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('label.name')), 1),
            _createVNode(InputSimple, {
              class: "mt-1 unset-max-width",
              "input-class": "grey4-grey4-background",
              modelValue: timerSettings.value.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((timerSettings.value.name) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }),
    _createVNode(_unref(IonRow), { class: "pt-1 width-custom" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonCol), {
          class: _normalizeClass(__props.cssClass)
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('messages.list.repeatEach1')), 1),
            _createVNode(SelectSimple, {
              class: "mt-1 grey4-grey4-background chevron-select unset-max-width",
              modelValue: timerSettings.value.type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((timerSettings.value.type) = $event)),
              options: _unref(repeatOptions)
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }),
    (timerSettings.value.type === _unref(REPEAT_CYCLE).ONCE)
      ? (_openBlock(), _createBlock(_unref(IonRow), {
          key: 1,
          class: "purple-purple-color mt-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "center py-2" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonDatetime), {
                  class: "grey4-grey4-background custom-datetime card-border order-filter-month",
                  min: today.value ?? '',
                  max: (new Date().getFullYear() + 1).toString(),
                  modelValue: timerSettings.value.date,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((timerSettings.value.date) = $event)),
                  locale: _ctx.$i18n.locale,
                  "first-day-of-week": 1
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('label.time')), 1)
                  ]),
                  _: 1
                }, 8, ["min", "max", "modelValue", "locale"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (timerSettings.value.type === _unref(REPEAT_CYCLE).WEEK)
      ? (_openBlock(), _createBlock(_unref(IonRow), {
          key: 2,
          class: "d-flex purple-light-color mt-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), {
              class: _normalizeClass(["center-y", __props.cssClass]),
              style: {"gap":".75rem"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('messages.list.repeatEach2')), 1),
                _createVNode(InputSimple, {
                  type: _unref(INPUT_TYPE).NUMBER,
                  modelValue: timerSettings.value.interval.every,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((timerSettings.value.interval.every) = $event)),
                  modelModifiers: { positive: true },
                  "input-class": "grey4-grey4-background",
                  min: 1
                }, null, 8, ["type", "modelValue"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`enumT.repeatCycle.appendix.${timerSettings.value.type}`)), 1)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (timerSettings.value.type === _unref(REPEAT_CYCLE).WEEK)
      ? (_openBlock(), _createBlock(_unref(IonRow), { key: 3 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WEEKDAY), (day) => {
              return (_openBlock(), _createBlock(_unref(IonCol), {
                key: day,
                size: "6",
                class: _normalizeClass(__props.cssClass)
              }, {
                default: _withCtx(() => [
                  _createVNode(CheckboxSimple, {
                    "label-class": "",
                    value: timerSettings.value.interval.days.includes(day),
                    "onUpdate:modelValue": ($event: any) => (changeTimeDays($event, day))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(`enumT.weekday.${day}`)), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["class"]))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (timerSettings.value.type === _unref(REPEAT_CYCLE).WEEK)
      ? (_openBlock(), _createBlock(_unref(IonRow), {
          key: 4,
          class: "mt-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), {
              size: "3",
              class: _normalizeClass(["center-y", __props.cssClass])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('label.time')), 1)
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_unref(IonCol), null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "time",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((timerSettings.value.interval.time) = $event)),
                  class: "deactivate-focus purple-purple-color grey4-grey4-background",
                  style: {"border-radius":"8px","min-height":"40px","border":"none","padding-left":"10px"}
                }, null, 512), [
                  [_vModelText, timerSettings.value.interval.time]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(IonRow), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonCol), { class: "center-x" }, {
          default: _withCtx(() => [
            (!__props.timer.id)
              ? (_openBlock(), _createBlock(ButtonFix, {
                  key: 0,
                  disabled: !isValid.value,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('save', timerSettings.value))),
                  class: _normalizeClass({'coral-light-background inherit-background light-coral-color': __props.settings})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('button.add')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "class"]))
              : (_openBlock(), _createBlock(ButtonFix, {
                  key: 1,
                  disabled: !isValid.value,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('edit', timerSettings.value))),
                  class: _normalizeClass({'coral-light-background inherit-background light-coral-color': __props.settings})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('button.save')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "class"]))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})